import React__default, { createContext, useContext, useReducer, useMemo } from 'react';
import { messagesReducer, initialMessagesState } from './reducer.js';
import { MessageProviderToast } from './components/MessageProviderToast.js';
import { ToastWrapper } from './styles.js';
import { INITIAL_MESSAGE_CONTEXT_VALUE, TOAST_TYPE_COMPACT, TOAST_TYPE_DEFAULT, AUTO_HIDE_DURATION_DEFAULT, MESSAGE_POSITION_DEFAULT } from './constants.js';
import { createMessageMethods } from './utils/createMessageMethods.js';

const MessageContext = createContext(INITIAL_MESSAGE_CONTEXT_VALUE);
const useMessageContext = () => useContext(MessageContext);
const defaultProviderOption = {
    action: 'acknowledge',
    autoHideDuration: AUTO_HIDE_DURATION_DEFAULT,
    position: MESSAGE_POSITION_DEFAULT,
    toastType: TOAST_TYPE_COMPACT,
};
function MessageProvider({ children, options }) {
    const [state, dispatch] = useReducer(messagesReducer, initialMessagesState);
    const providerOptions = Object.assign(Object.assign({}, defaultProviderOption), options);
    const methods = useMemo(() => (Object.assign({ compact: createMessageMethods(dispatch, Object.assign(Object.assign({}, providerOptions), { toastType: TOAST_TYPE_COMPACT })), default: createMessageMethods(dispatch, Object.assign(Object.assign({}, providerOptions), { toastType: TOAST_TYPE_DEFAULT })) }, createMessageMethods(dispatch, providerOptions))), []);
    return (React__default.createElement(MessageContext.Provider, { value: methods },
        React__default.createElement(ToastWrapper, { position: providerOptions.position }, state.messages.map((message) => (React__default.createElement(MessageProviderToast, Object.assign({}, message, { key: message.id, position: providerOptions.position }))))),
        children));
}

export { MessageProvider, useMessageContext };
